import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators
} from '@angular/forms';
import { Router } from '@angular/router';
import { rutFormat } from 'rut-helpers';
import { Subscription } from 'rxjs';
import { ReCaptchaV3Service } from 'ng-recaptcha';

import { rutValidator, Loadable } from '@fenix/shared';

import { EncryptRSAService } from '../../../services/encrypt-rsa.service';
import { SerialValidador } from '../../../directives/validar-numero-documento.directive';
import { CONFIG_URL_CAPTCHA } from '../../../constants/lottie.constants';
import { ValidacionClienteService } from '../../../services/validacion-cliente.service';
import { CatalogoMensaje } from '../../../constants/catalogo';
import { AnalyticsService } from '../../../services/analytics.service';
import { AuthGuard } from '../../../guard/auth.guard';
import { CallEquifaxService } from '../../../services/call-equifax.service';

@Component({
  selector: 'app-formulario',
  templateUrl: './formulario.component.html',
  styleUrls: ['./formulario.component.scss']
})
export class FormularioComponent implements OnInit, OnDestroy {
  private readonly subs = new Subscription();
  privacidad: string;
  condiciones: string;
  servicioIntermitente = CatalogoMensaje.servicioIntermitente;
  @Input() title: string;
  errorServicioEquifax: string;
  form: FormGroup;
  preguntas = new Loadable<any>();
  infoIdentidad = CatalogoMensaje.infoIdentidad;
  mensajeErrorBloqueo = CatalogoMensaje.mensajeErrorBloqueo;
  mensajeErrorCelular = CatalogoMensaje.mensajeErrorCelular;
  load = false;
  loadingComponent = false;
  get rutValue() {
    return this.form.get('rut') as FormControl;
  }
  get cedulaValue() {
    return this.form.get('cedula') as FormControl;
  }
  buttonContinuar = {
    text: 'CONTINUAR',
    class: 'btn-primary',
    type: 'button'
  };
  private subscription: Subscription;
  activeSerialInformation: boolean;
  rutSinPunto: string;
  currentProgress = { value: 50 };
  constructor(
    private readonly router: Router,
    private readonly recaptchaV3Service: ReCaptchaV3Service,
    private readonly validacionClienteService: ValidacionClienteService,
    private readonly fb: FormBuilder,
    private readonly directiveValidaNumeroDocumento: SerialValidador,
    private readonly analyticsService: AnalyticsService,
    private readonly authGuard: AuthGuard,
    private readonly encryptService: EncryptRSAService,
    private readonly callEquifaxService: CallEquifaxService
  ) {
    this.authGuard.setActivated = false;
    this.privacidad = CONFIG_URL_CAPTCHA.url_captcha_privacy;
    this.condiciones = CONFIG_URL_CAPTCHA.url_captcha_terms;
    this.form = this.fb.group({
      rut: new FormControl('', [rutValidator]),
      cedula: [
        '',
        [
          this.directiveValidaNumeroDocumento,
          Validators.maxLength(11),
          Validators.required
        ]
      ]
    });
  }

  ngOnInit(): void {
    this.analyticsService.pageView({
      screen_name: 'estado de situacion :: inicio'
    });
  }

  public validateFormAndExecuteCaptcha(): void {
    this.load = true;
    this.loadingComponent = true;
    this.analyticsService.btnClick({
      label: 'continuar',
      action: 'click',
      channel: 'browser',
      element_id: undefined,
      type: 'button',
      section: 'inicio'
    });
    this.subscription = this.recaptchaV3Service
      .execute('eessPublico')
      .subscribe((token) => this.handleToken(token));
  }
  handleToken(token) {
    this.sendForm(token);
  }
  public ngOnDestroy(): void {
    // Cancela la suscripción si está activa
    if (this.subscription && !this.subscription.closed) {
      this.subscription.unsubscribe();
    }
  }
  rutFormater() {
    this.form.controls['rut'].setValue(rutFormat(this.form.controls.rut.value));
  }
  get formulario() {
    return this.form.controls;
  }
  sendForm(token: string) {
    const encryptedCedula = this.cedulaValue.value.split('.').join('');
    this.rutSinPunto = this.form.controls.rut.value.trim().split('.').join('');
    const sub = this.validacionClienteService
      .validarEsCliente(this.rutSinPunto, token)
      .subscribe(
        async (data) => {
          if (data) {
            this.authGuard.setActivated = true;
            this.router.navigate(['estado-situacion/cliente'], {
              state: {
                rutSinPunto: this.rutSinPunto,
                encryptedCedula: encryptedCedula
              }
            });
            this.loadingComponent = false;
          } else {
            this.load = false;
            this.errorServicioEquifax =
              await this.callEquifaxService.setSecurityQuestions(
                this.rutSinPunto,
                encryptedCedula
              );
            this.loadingComponent = false;
          }
        },
        (error) => {
          this.load = false;
          this.loadingComponent = false;
          this.errorServicioEquifax = this.servicioIntermitente;
        }
      );
    this.subs.add(sub);
  }

  setEventAnalytics(msg: string) {
    this.errorServicioEquifax = msg;
    this.analyticsService.mensaje({
      label: msg,
      action: 'view',
      channel: 'browser',
      element_id: undefined,
      type: 'alert warning',
      section: 'inicio'
    });
  }
}
